/**
 * A versão do sistema, congelada em tempo de build.
 *
 * `__VERSAO_DO_SISTEMA__` é substituído pelo Vite (`define` em `vite.config.ts`) pela TAG da
 * imagem publicada. O `declare` existe porque, para o TypeScript, essa constante não vem de lugar
 * nenhum — ela aparece no código já substituída por uma string literal.
 *
 * O fallback não é decoração: em teste (Vitest usa o mesmo `define`) e em qualquer caminho que
 * escape do build do Vite, um `undefined` viraria "Versão undefined" no rodapé de todas as telas.
 * Melhor dizer que não se sabe do que exibir lixo com cara de dado.
 */
declare const __VERSAO_DO_SISTEMA__: string | undefined

/** @returns a versão do build em execução, ou `'—'` quando não foi injetada */
export function versaoDoSistema(): string {
  return typeof __VERSAO_DO_SISTEMA__ === 'string' && __VERSAO_DO_SISTEMA__ !== ''
    ? __VERSAO_DO_SISTEMA__
    : '—'
}
